import { I18N_DOMAIN } from '../settings';
import PrePublishHeader from './prepublish/PrePublishHeader';

const { compose } = wp.compose;
const { withDispatch, withSelect } = wp.data;
const { Component } = wp.element;
const { __, sprintf } = wp.i18n;

class EpisodeDuration extends Component {
	isBlocked = () => {
		const { episodeDuration } = this.props;
		if (episodeDuration === '') {
			return true;
		}
		return false;
	};

	render() {
		const { updatedStatus } = this.props;
		let title = 'published';
		if (updatedStatus === 'updated' || updatedStatus === 'publish') {
			title = 'updated';
		}

		return (
			<>
				<PrePublishHeader.Approval
					name="ib-podcast-duration"
					display={this.isBlocked}
					type="blocker"
				>
					<p>
						{sprintf(__('A Podcast cannot be %s without an Episode Duration.', I18N_DOMAIN), title)}
					</p>
				</PrePublishHeader.Approval>
			</>
		);
	}
}

export default compose([
	withSelect(select => {
		const { getEditedPostAttribute } = select('core/editor');
		const { episode_duration: episodeDuration } = getEditedPostAttribute('meta');
		const updatedStatus = getEditedPostAttribute('status');

		return {
			episodeDuration,
			updatedStatus,
		};
	}),
	withDispatch(dispatch => ({
		editPost: dispatch('core/editor').editPost,
	})),
])(EpisodeDuration);
